<template>
  <div>
    <AppLayout title="Agenda">
      <template #actions>
        <button type="button" @click="show_newAppointment()" class="btn btn-primary">Novo Agendamento</button>
      </template>

      <div class="d-flex align-items-center gap-2 mb-3 flex-wrap">
        <div class="btn-group btn-group-sm">
          <button type="button" class="btn" :class="viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'" @click="mudarParaVisaoLista()">
            <i class="bi bi-list-ul me-1"></i>Lista
          </button>
          <button type="button" class="btn" :class="viewMode === 'month' ? 'btn-primary' : 'btn-outline-secondary'" @click="mudarParaVisaoMes()">
            <i class="bi bi-calendar3 me-1"></i>Mês
          </button>
        </div>

        <template v-if="viewMode === 'list'">
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="mudarDia(-1)"><i class="bi bi-chevron-left"></i></button>
          <input type="date" v-model="diaSelecionado" @change="refresh" class="form-control form-control-sm" style="max-width: 180px;">
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="mudarDia(1)"><i class="bi bi-chevron-right"></i></button>
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="hoje">Hoje</button>
        </template>
        <template v-else>
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="mudarMes(-1)"><i class="bi bi-chevron-left"></i></button>
          <strong class="text-capitalize" style="min-width: 140px; text-align: center;">{{ nomeMesAno }}</strong>
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="mudarMes(1)"><i class="bi bi-chevron-right"></i></button>
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="mesAtual">Hoje</button>
        </template>
      </div>

      <div class="table-card" v-if="viewMode === 'list'">
        <table class="table">
          <thead>
            <tr>
              <th>Horário</th>
              <th>Serviço</th>
              <th>Cliente</th>
              <th>Operador</th>
              <th>Status</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ag in lista_agendamentos" :key="ag.id">
              <td>{{ formatHora(ag.scheduled_at) }} &ndash; {{ formatHoraFim(ag) }}</td>
              <td>{{ ag.service?.name }}</td>
              <td>{{ ag.customer?.name ?? 'Avulso' }}</td>
              <td>{{ ag.operator?.name ?? '—' }}</td>
              <td><span class="badge" :class="statusBadge(ag.status)">{{ statusLabel(ag.status) }}</span></td>
              <td style="width:50px">
                <button v-if="ag.status === 'scheduled'" @click="marcarStatus(ag, 'completed')" type="button" class="btn btn-success btn-sm" title="Concluir">
                  <i class="bi bi-check-lg"></i>
                </button>
              </td>
              <td style="width:50px">
                <button @click="show_deleteAppointment(ag)" type="button" class="btn btn-danger btn-sm" title="Excluir">
                  <i class="bi bi-trash-fill"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!lista_agendamentos.length">
              <td colspan="7" class="text-center text-muted">Nenhum agendamento neste dia.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Visão mensal: grade de dias, clicar num dia volta pra visão em
           lista já naquela data (ver abrirDiaDoMes). -->
      <div class="calendar-month" v-else>
        <div class="calendar-month__weekdays">
          <div v-for="d in diasSemana" :key="d">{{ d }}</div>
        </div>
        <div class="calendar-month__grid">
          <div
            v-for="(dia, index) in celulasCalendario"
            :key="index"
            class="calendar-month__cell"
            :class="{ 'calendar-month__cell--empty': !dia, 'calendar-month__cell--today': dia?.isToday, 'calendar-month__cell--clickable': dia }"
            @click="dia && abrirDiaDoMes(dia.date)"
          >
            <template v-if="dia">
              <div class="calendar-month__daynum">{{ dia.dayNumber }}</div>
              <div class="calendar-month__events">
                <div v-for="ag in dia.agendamentos.slice(0, 3)" :key="ag.id" class="calendar-month__event" :class="statusBadge(ag.status)">
                  {{ formatHora(ag.scheduled_at) }} {{ ag.service?.name }}
                </div>
                <div v-if="dia.agendamentos.length > 3" class="calendar-month__more">+{{ dia.agendamentos.length - 3 }} mais</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </AppLayout>

    <!-- Modal Novo Agendamento -->
    <div class="modal fade" id="modal_agendamento" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Novo Agendamento</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="form-agendamento">
              <div class="mb-3" v-if="lista_lojas.length > 1">
                <label for="inp_store" class="form-label">Loja:</label>
                <select v-model="selectedStoreId" class="form-select" id="inp_store">
                  <option v-for="loja in lista_lojas" :key="loja.id" :value="loja.id">{{ loja.name }}</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="inp_service" class="form-label">Serviço:</label>
                <select v-model="agendamento.service_id" @change="preencherDuracao" class="form-select" id="inp_service">
                  <option value="" disabled>Selecione...</option>
                  <option v-for="s in lista_servicos" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="inp_customer" class="form-label">Cliente:</label>
                <select v-model="agendamento.customer_id" class="form-select" id="inp_customer">
                  <option :value="null">Avulso</option>
                  <option v-for="c in lista_clientes" :key="c.id" :value="c.id">{{ c.name }}</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="inp_operator" class="form-label">Operador (opcional):</label>
                <select v-model="agendamento.operator_id" class="form-select" id="inp_operator">
                  <option :value="null">A definir</option>
                  <option v-for="o in lista_operadores" :key="o.id" :value="o.id">{{ o.name }}</option>
                </select>
              </div>
              <div class="row">
                <div class="mb-3 col">
                  <label for="inp_datetime" class="form-label">Data e hora:</label>
                  <input v-model="agendamento.scheduled_at" type="datetime-local" class="form-control" id="inp_datetime">
                </div>
                <div class="mb-3 col">
                  <label for="inp_duration" class="form-label">Duração (min):</label>
                  <input v-model="agendamento.duration_minutes" type="number" min="1" class="form-control" id="inp_duration">
                </div>
              </div>
              <div class="mb-3">
                <label for="inp_notes" class="form-label">Observações:</label>
                <textarea v-model="agendamento.notes" class="form-control" id="inp_notes" rows="2"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" @click="salvarAgendamento()" class="btn btn-primary">Agendar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Excluir agendamento?</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body"><p>{{ agendamentoParaExcluir?.service?.name }} &mdash; {{ agendamentoParaExcluir ? formatHora(agendamentoParaExcluir.scheduled_at) : '' }}</p></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button @click="deleteAppointment()" class="btn btn-danger">Excluir</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ feedback_error ? 'Erro' : 'Sucesso' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body"><p>{{ msn_feedback }}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, reactive, ref } from 'vue';
import { Modal } from "bootstrap";
import AppLayout from "@/components/AppLayout.vue";
import { agenda } from "@/models/agenda";
import { servicos } from "@/models/servicos";
import { clientes } from "@/models/clientes";
import { operator } from "@/models/operator";
import { lojas } from "@/models/lojas";

export default {
  name: 'AgendaView',
  components: { AppLayout },
  setup() {
    const Agenda = agenda();
    const Servicos = servicos();
    const Clientes = clientes();
    const Operadores = operator();
    const Lojas = lojas();

    const lista_agendamentos = ref([]);
    const lista_servicos = ref([]);
    const lista_clientes = ref([]);
    const lista_operadores = ref([]);
    const lista_lojas = ref([]);
    const selectedStoreId = ref(null);
    const diaSelecionado = ref(new Date().toISOString().slice(0, 10));
    const msn_feedback = ref('');
    const feedback_error = ref(false);
    const agendamentoParaExcluir = ref(null);

    // ----- Visão mensal -----
    const viewMode = ref('list'); // 'list' (como já era) ou 'month'
    const mesSelecionado = ref(new Date().toISOString().slice(0, 7)); // 'YYYY-MM'
    const lista_agendamentos_mes = ref([]);
    const diasSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

    let modalAgendamento = null;
    let modalDeletar = null;
    let modalFeedback = null;

    const agendamento = reactive({
      service_id: '', customer_id: null, operator_id: null, scheduled_at: '', duration_minutes: 60, notes: '',
    });

    function openModal(id) {
      const el = document.getElementById(id);
      const instance = Modal.getOrCreateInstance(el);
      instance.show();
      return instance;
    }

    function statusLabel(status) {
      return { scheduled: 'Agendado', completed: 'Concluído', cancelled: 'Cancelado' }[status] ?? status;
    }

    function statusBadge(status) {
      return {
        scheduled: 'text-bg-primary',
        completed: 'text-bg-success',
        cancelled: 'text-bg-secondary',
      }[status] ?? 'text-bg-secondary';
    }

    function formatHora(iso) {
      return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    }

    function formatHoraFim(ag) {
      const fim = new Date(new Date(ag.scheduled_at).getTime() + ag.duration_minutes * 60000);
      return fim.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    }

    // Dispara pra visão certa — assim marcarStatus/deleteAppointment/
    // salvarAgendamento (que só chamam refresh()) atualizam tanto a lista
    // quanto o calendário sem precisar saber qual está ativa.
    const refresh = async () => {
      if (viewMode.value === 'month') {
        await refreshMes();
        return;
      }
      const resultado = await Agenda.list(diaSelecionado.value, diaSelecionado.value);
      lista_agendamentos.value = resultado ?? [];
    };

    const mudarDia = (delta) => {
      const d = new Date(diaSelecionado.value + 'T00:00:00');
      d.setDate(d.getDate() + delta);
      diaSelecionado.value = d.toISOString().slice(0, 10);
      refresh();
    };

    const hoje = () => {
      diaSelecionado.value = new Date().toISOString().slice(0, 10);
      refresh();
    };

    // ----- Visão mensal -----

    function toLocalDateStr(data) {
      const d = data instanceof Date ? data : new Date(data);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    function ultimoDiaDoMes(mesStr) {
      const [ano, mes] = mesStr.split('-').map(Number);
      return `${mesStr}-${String(new Date(ano, mes, 0).getDate()).padStart(2, '0')}`;
    }

    const refreshMes = async () => {
      const resultado = await Agenda.list(mesSelecionado.value + '-01', ultimoDiaDoMes(mesSelecionado.value));
      lista_agendamentos_mes.value = resultado ?? [];
    };

    const nomeMesAno = computed(() => {
      const d = new Date(mesSelecionado.value + '-01T00:00:00');
      return d.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
    });

    const celulasCalendario = computed(() => {
      const [ano, mes] = mesSelecionado.value.split('-').map(Number);
      const primeiroDiaSemana = new Date(ano, mes - 1, 1).getDay();
      const totalDias = new Date(ano, mes, 0).getDate();
      const hojeStr = toLocalDateStr(new Date());

      const porDia = {};
      lista_agendamentos_mes.value.forEach(ag => {
        (porDia[toLocalDateStr(ag.scheduled_at)] ??= []).push(ag);
      });

      const celulas = [];
      for (let i = 0; i < primeiroDiaSemana; i++) celulas.push(null);
      for (let dia = 1; dia <= totalDias; dia++) {
        const dataStr = `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
        celulas.push({
          date: dataStr,
          dayNumber: dia,
          isToday: dataStr === hojeStr,
          agendamentos: (porDia[dataStr] ?? []).slice().sort((a, b) => a.scheduled_at.localeCompare(b.scheduled_at)),
        });
      }
      return celulas;
    });

    const mudarMes = (delta) => {
      const [ano, mes] = mesSelecionado.value.split('-').map(Number);
      const d = new Date(ano, mes - 1 + delta, 1);
      mesSelecionado.value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      refreshMes();
    };

    const mesAtual = () => {
      mesSelecionado.value = new Date().toISOString().slice(0, 7);
      refreshMes();
    };

    function mudarParaVisaoMes() {
      viewMode.value = 'month';
      refreshMes();
    }

    function mudarParaVisaoLista() {
      viewMode.value = 'list';
      refresh();
    }

    // Clicar num dia no calendário volta pra visão em lista já naquela data.
    function abrirDiaDoMes(date) {
      diaSelecionado.value = date;
      viewMode.value = 'list';
      refresh();
    }

    const preencherDuracao = () => {
      const servico = lista_servicos.value.find(s => s.id === agendamento.service_id);
      if (servico?.duration_minutes) {
        agendamento.duration_minutes = servico.duration_minutes;
      }
    };

    const show_newAppointment = () => {
      agendamento.service_id = '';
      agendamento.customer_id = null;
      agendamento.operator_id = null;
      agendamento.scheduled_at = diaSelecionado.value + 'T09:00';
      agendamento.duration_minutes = 60;
      agendamento.notes = '';
      modalAgendamento = openModal('modal_agendamento');
    };

    const salvarAgendamento = async () => {
      const resultado = await Agenda.createItem({ ...agendamento, store_id: selectedStoreId.value });
      if (resultado === true) {
        modalAgendamento?.hide();
        refresh();
      } else {
        feedback_error.value = true;
        msn_feedback.value = typeof resultado === 'string' ? resultado : 'Erro ao agendar.';
        modalFeedback = openModal('modal_feedback');
      }
    };

    const marcarStatus = async (ag, status) => {
      if (await Agenda.updateItem({ id: ag.id, status })) {
        refresh();
      }
    };

    const show_deleteAppointment = (ag) => {
      agendamentoParaExcluir.value = ag;
      modalDeletar = openModal('modal_deletar');
    };

    const deleteAppointment = async () => {
      if (await Agenda.deleteItem(agendamentoParaExcluir.value.id)) {
        modalDeletar?.hide();
        refresh();
      }
    };

    onMounted(async () => {
      lista_servicos.value = await Servicos.list() ?? [];
      lista_clientes.value = await Clientes.list() ?? [];
      lista_operadores.value = await Operadores.list() ?? [];
      lista_lojas.value = await Lojas.list();
      selectedStoreId.value = (lista_lojas.value.find(l => l.is_default) ?? lista_lojas.value[0])?.id ?? null;
      refresh();
    });

    return {
      lista_agendamentos, lista_servicos, lista_clientes, lista_operadores, lista_lojas, selectedStoreId,
      diaSelecionado, agendamento, msn_feedback, feedback_error, agendamentoParaExcluir,
      statusLabel, statusBadge, formatHora, formatHoraFim,
      mudarDia, hoje, refresh, preencherDuracao,
      show_newAppointment, salvarAgendamento, marcarStatus,
      show_deleteAppointment, deleteAppointment,
      viewMode, diasSemana, nomeMesAno, celulasCalendario,
      mudarMes, mesAtual, mudarParaVisaoMes, mudarParaVisaoLista, abrirDiaDoMes,
    };
  },
}
</script>
<style scoped>
.calendar-month {
  background: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 1rem;
}

.calendar-month__weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
  text-align: center;
}

.calendar-month__grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
}

.calendar-month__cell {
  min-height: 100px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  padding: 0.4rem;
}

.calendar-month__cell--empty {
  border-color: transparent;
}

.calendar-month__cell--clickable {
  cursor: pointer;
}

.calendar-month__cell--clickable:hover {
  background: var(--surface-muted);
}

.calendar-month__cell--today {
  border-color: var(--brand);
  border-width: 2px;
}

.calendar-month__daynum {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-strong);
  margin-bottom: 0.25rem;
}

.calendar-month__events {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.calendar-month__event {
  font-size: 0.68rem;
  padding: 1px 4px;
  border-radius: 4px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-month__more {
  font-size: 0.68rem;
  color: var(--text-muted);
}

@media (max-width: 768px) {
  .calendar-month__weekdays div:nth-child(n) {
    font-size: 0.6rem;
  }

  .calendar-month__cell {
    min-height: 60px;
  }
}
</style>
